var render = function render(){var _vm=this,_c=_vm._self._c;return (this.app === null)?_c('b-container',[_c('b-row',{staticClass:"vh-100 text-center",attrs:{"align-v":"center"}},[_c('b-col',[_c('b-spinner',{attrs:{"variant":"light"}})],1)],1)],1):_c('TemplateEditor',{attrs:{"nodes":_vm.nodes,"saving":_vm.saving},on:{"save":_vm.save}})
}
var staticRenderFns = []

export { render, staticRenderFns }